import React from 'react';

const KidsDailyActivity = () => {
    return (
      <div className="py-12 px-6">
        <h1 className="lg:text-5xl font-bold mb-12 mt-4 text-center">
          Kids_%Daily_%Activity
        </h1>
        <div className="carousel carousel-center w-full p-4 space-x-4 rounded-box">
          <div className="carousel-item h-[200px]">
            <img
              src="https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/adorable-children-playing-with-constructor-in-kind-Y6DJRAG.jpg"
              className="rounded-box"  alt="sorry"
            />
          </div>
          <div className="carousel-item h-[200px]">
            <img
              src="https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/group-of-diverse-students-at-daycare-PEBBJWW.jpg"
              className="rounded-box" alt="sorry"
            />
          </div>
          <div className="carousel-item h-[200px]">
            <img
              src="https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/group-painting-in-kindergarten-PPB6ZV7.jpg"
              className="rounded-box" alt="sorry"
            />
          </div>
          <div className="carousel-item h-[200px]">
            <img
              src="https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/adorable-children-playing-with-constructor-in-kind-Y6DJRAG.jpg"
              className="rounded-box" alt="sorry"
            />
          </div>
          <div className="carousel-item h-[200px]">
            <img
              src="https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/group-of-diverse-students-at-daycare-PEBBJWW.jpg"
              className="rounded-box" alt="sorry"
            />
          </div>
          <div className="carousel-item h-[200px]">
            <img
              src="https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/group-of-diverse-students-at-daycare-PEBBJWW.jpg"
              className="rounded-box" alt="sorry"
            />
          </div>
          <div className="carousel-item h-[200px]">
            <img
              src="https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/group-of-diverse-students-at-daycare-PEBBJWW.jpg"
              className="rounded-box" alt="sorry"
            />
          </div>
        </div>
        <div className="carousel carousel-center w-full p-4 space-x-4 rounded-box">
          <div className="carousel-item h-[200px]">
            <img
              src="https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/adorable-children-playing-with-constructor-in-kind-Y6DJRAG.jpg"
              className="rounded-box" alt="sorry"
            />
          </div>
          <div className="carousel-item h-[200px]">
            <img
              src="https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/group-of-diverse-students-at-daycare-PEBBJWW.jpg"
              className="rounded-box" alt="sorry"
            />
          </div>
          <div className="carousel-item h-[200px]">
            <img
              src="https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/group-painting-in-kindergarten-PPB6ZV7.jpg"
              className="rounded-box" alt="sorry"
            />
          </div>
          <div className="carousel-item h-[200px]">
            <img
              src="https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/adorable-children-playing-with-constructor-in-kind-Y6DJRAG.jpg"
              className="rounded-box" alt="sorry"
            />
          </div>
          <div className="carousel-item h-[200px]">
            <img
              src="https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/group-of-diverse-students-at-daycare-PEBBJWW.jpg"
              className="rounded-box" alt="sorry"
            />
          </div>
          <div className="carousel-item h-[200px]">
            <img
              src="https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/group-of-diverse-students-at-daycare-PEBBJWW.jpg"
              className="rounded-box" alt="sorry"
            />
          </div>
          <div className="carousel-item h-[200px]">
            <img
              src="https://templatekit.mattsapii.co/padora/wp-content/uploads/sites/5/2020/12/group-of-diverse-students-at-daycare-PEBBJWW.jpg"
              className="rounded-box" alt="sorry"
            />
          </div>
        </div>
      </div>
    );
};

export default KidsDailyActivity;